import axios from "axios";
import { API_URL, getAuthHeader } from ".";

export interface PublicCompanyDto {
  id: number;
  companyName?: string | null;
}

export interface PublicCompanyCreateRequest {
  companyName: string;
  email?: string | null;
  phone?: string | null;
  website?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
}

class PublicCompanyApi {
  static getAll() {
    return axios.get<PublicCompanyDto[]>(
      `${API_URL}/api/publiccompany`,
      getAuthHeader()
    );
  }

  static create(request: PublicCompanyCreateRequest) {
    return axios.post<PublicCompanyDto>(
      `${API_URL}/api/publiccompany`,
      request,
      getAuthHeader()
    );
  }
}

export default PublicCompanyApi;
